import {buildContactUid, ContactSourcesEnum} from '../../../libs/shared/core/src/models/api/contactModel';
import {ParticipantModel, ParticipantTypesEnum} from '../../models/api/participantModel';

// Google's "Out of Office" and "Focus Time" events use this address as the organizer.
// Furthermore, because one cannot add other participants for these types of events, we can safely
// determine that this is a proxy address for the actual organizer.
const GCAL_PROXY_ORGANIZER = buildContactUid(
  ContactSourcesEnum.EMAIL,
  'unknownorganizer@calendar.google.com',
);

export function isProxyOrganizer(contactUid: string) {
  return contactUid === GCAL_PROXY_ORGANIZER;
}

// Compute the number of non-organizer and non-resource participants.
// This is used to determine whether rescheduling or delete confirmation dialogs are necessary when editing an event.
export function computeNonResourceGuestCount(participants: ReadonlyArray<ParticipantModel>): number {
  const hasProxyOrganizer = participants.find((p) => isProxyOrganizer(p.contactUid));

  // Events with proxy organizers aren't allowed to have guests.
  if (hasProxyOrganizer) {
    return 0;
  }

  const nonOrganizerNonResourceAttendees = participants.filter(
    (p) => !p.isOrganizer && p.isAttendee && p.type !== ParticipantTypesEnum.RESOURCE,
  );
  return nonOrganizerNonResourceAttendees.length;
}
